import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import timezone from 'moment-timezone';
// ANTD
import Calendar from 'antd/lib/calendar';
import 'antd/lib/calendar/style/css';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/css';
import Modal from 'antd/lib/modal';
import 'antd/lib/modal/style/css';
// APOLLO
import { graphql, compose } from 'react-apollo';
import sessionFragment from 'ApolloClient/Fragments/sessionFragment';
import sessionsQuery from 'ApolloClient/Queries/sessions';
// MODULES
import LoadingCard from './LoadingCard';
// COMPONENTS
import SaveCalendarSession from 'components/common/SaveCalendarSession';
import DateCell from './DateCell';
import ModalContent from './ModalContent';

const USER_TIMEZONE = timezone.tz.guess() || 'America/New_York';

//------------------------------------------------------------------------------
// AUX FUNCTIONS:
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// COMPONENT:
//------------------------------------------------------------------------------
class NedCalendar extends React.Component {
  state = {
    value: moment(),
    selectedValue: moment(),
    selectedEvent: null,
    visible: false,
    saveModalIsVisible: false,
  };

  onSelect = value => {
    this.setState({
      value,
      selectedValue: value,
    });
  };

  onOk = () => {
    const { history } = this.props;
    const { selectedEvent } = this.state;

    const clientId = selectedEvent.client._id;
    this.setState({ visible: false, selectedEvent: null }, () => history.push(`/app/clients/${clientId}`));
  };

  onPanelChange = value => {
    this.setState({ value });
  };

  getDataForDay = cellDate => {
    const {
      data: { sessions },
    } = this.props;

    const dataForDay =
      (sessions &&
        sessions.filter(item => {
          const sessionDate = moment.utc(item.sessionDate).format('YYYY-MM-DD');
          const fCellDate = cellDate.format('YYYY-MM-DD');
          if (sessionDate === fCellDate) {
          }

          return sessionDate === fCellDate;
        })) ||
      [];

    return dataForDay;
  };

  getDataForMonth = cellDate => {
    const {
      data: { sessions },
    } = this.props;

    const dataForMonth =
      (sessions &&
        sessions.filter(item => {
          const sessionDate = moment.utc(item.sessionDate);
          return sessionDate
            .tz(USER_TIMEZONE)
            .utc()
            .isSame(cellDate, 'month');
        })) ||
      [];

    return dataForMonth;
  };

  selectSession = selectedEvent => {
    this.setState({ selectedEvent });
  };

  toggleModal = () => {
    this.setState({ visible: !this.state.visible });
  };

  dateCellRender = cellDate => {
    const listData = this.getDataForDay(cellDate.tz(USER_TIMEZONE).utc());
    return (
      <DateCell listData={listData} selectSession={item => this.selectSession(item)} toggleModal={this.toggleModal} />
    );
  };

  monthCellRender = value => {
    const sessions = this.getDataForMonth(value);
    return sessions && sessions.length ? (
      <div className="notes-month">
        <section>
          <span style={{ color: '#000', fontSize: 15 }}>{sessions.length}</span> <span>Sessions</span>
        </section>
      </div>
    ) : null;
  };

  toggleSave = () => {
    this.setState({ saveModalIsVisible: !this.state.saveModalIsVisible });
  };

  render() {
    const { value, visible, saveModalIsVisible, selectedEvent } = this.state;
    const { data, currentUser } = this.props;
    const { error, loading } = data;

    if (error) {
      console.log(error);
      return <span>Something went wrong :(</span>;
    }

    if (loading) {
      return <LoadingCard />;
    }

    const withCategory = selectedEvent && selectedEvent.sessionType && selectedEvent.sessionType.title;
    const withClient = selectedEvent && selectedEvent.client;
    const clientFirstName = withClient && withClient.firstName;
    const modalTitle = withCategory
      ? `${selectedEvent.sessionType.title} Event ${clientFirstName ? `with ${clientFirstName}` : ''}`
      : '';
    const withProfileBtn = !!withClient; // boolean
    let profileBtnLabel = '';

    if (clientFirstName) {
      profileBtnLabel = `Go to ${clientFirstName}'s Profile`;
    } else if (withClient) {
      profileBtnLabel = 'GO TO PROFILE';
    }

    return (
      <div style={{ maxWidth: '100%', margin: 'auto' }}>
        <Modal
          visible={visible}
          title={modalTitle}
          onCancel={() => this.setState({ visible: false, selectedEvent: null })}
          footer={false}
        >
          <div style={{ minHeight: 175 }}>
            <ModalContent
              selectedEvent={selectedEvent}
              onEdit={() => {
                // First, close content modal
                this.toggleModal();
                // Then, open edit modal
                this.toggleSave();
              }}
              withProfileBtn={withProfileBtn}
              profileBtnLabel={profileBtnLabel}
              onProfileBtnClick={this.onOk}
            />
          </div>
        </Modal>

        {/* Force re-render to clear form fields */}
        {saveModalIsVisible && (
          <Modal visible={saveModalIsVisible} footer={null} title="EDIT SESSION" onCancel={this.toggleSave}>
            <div className="flex justify-center align-center mx-auto">
              <SaveCalendarSession
                session={selectedEvent}
                onCancel={this.toggleSave}
                sessionTypes={[
                  selectedEvent.sessionType, // the session type from our event
                  ...currentUser.organization.sessionTypes, // all of the options currently selected
                ]}
                onComplete={this.toggleSave}
              />
            </div>
          </Modal>
        )}
        <Card bodyStyle={{ padding: 0 }}>
          <Calendar
            value={value}
            onSelect={this.onSelect}
            onPanelChange={this.onPanelChange}
            dateCellRender={this.dateCellRender}
            monthCellRender={this.monthCellRender}
          />
        </Card>
      </div>
    );
  }
}

NedCalendar.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    sessions: PropTypes.arrayOf(propType(sessionFragment)),
  }).isRequired,
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
};

const enhance = compose(
  withRouter, // provides access to history.push
  graphql(sessionsQuery), // provides access to sessions data
);

export default enhance(NedCalendar);



// WEBPACK FOOTER //
// ./src/components/common/NedCalendar/index.js